module.exports = __webpack_public_path__ + "2d4d7933f2f117f90710ff6852b01e5c.MP3";